import {Input, Button, Title} from "@mantine/core";
import React, {useState, useRef} from "react";
import Turnstile from "react-turnstile";
import { IconLogin } from '@tabler/icons-react';

import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import {NavMenu} from "../../components/GetNavMenu";
import {Footer} from "../../components/GetFooter";
import {FormContainer} from "../../components/form/FormContainer";

import {updateSubmit} from "../../logic/UpdateSubmit";
import {VerifyFormModel} from "../../models/forms/VerifyFormModel";
import {VerifyForm} from "../../logic/forms/VerifyForm";

async function VerifySubmit (body: VerifyFormModel) {
    // Clear notification banner and set button to loading state
    updateSubmit(body.submitButton, 'Verifying', true);
    body.setBanner(<></>)

    await VerifyForm(body);
    updateSubmit(body.submitButton, 'Verify', false);
}

export function Verify({memory}: SystemMemoryProps) {
    // Get verification code from URL
    const queryParameters = new URLSearchParams(window.location.search)
    let code = queryParameters.get('code');
    if (code === null) {
        code = "";
    }

    const inputs = {
        code: useRef(null),
        cfTurnstileToken: useRef("null")
    }

    // Create navigation and notification states
    const [notification, setNotification] = useState(<></>)

    // Check if the user is already logged in, if so redirect to the dashboard
    if (memory[0].isSignedIn) {
        memory[0].Router('/account/dashboard');
    }

    // Create submit button state with the submit button within it
    const submit = useState(
        <Button variant="light" color="indigo" radius="md" size="md" uppercase
                onClick={() => VerifySubmit({
                    memory: {memory},
                    setBanner: setNotification,
                    submitButton: submit,
                    inputs: inputs
                })}>
            Verify
        </Button>
    );

    // Create the verification form
    const form = (
        <>
            {notification}<br/>
            <Title align="center">Verify your Account</Title>
            <Input.Label required size={"lg"}>Verification Code</Input.Label>
            <Input
                placeholder="Your verification code"
                icon={<IconLogin size={"1rem"}/>}
                variant="filled"
                radius="md"
                size="lg"
                ref={inputs.code}
                defaultValue={code}
            /><br/>
            <center>
                <Turnstile
                    sitekey={memory[0].CFSiteKey}
                    onVerify={(token) => {
                        inputs.cfTurnstileToken.current = token
                    }}/><br/>
                {submit[0]}
            </center>
        </>
    )

    return (
        <>
            <NavMenu memory={memory}></NavMenu>
            {FormContainer(form)}
            <Footer data={[]}></Footer>
        </>
    )
}